import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import Modal from "react-modal";

interface IModalProps {
  open: boolean;
  title: string;
  handleClose: () => void;
  children: React.ReactNode;
}

export default function ModalDialog({
  open,
  title,
  handleClose,
  children,
}: IModalProps) {
  return (
    <Modal
      isOpen={open}
      onRequestClose={handleClose}
      className="bg-primary-100 flex flex-col  rounded-xl absolute top-1/2 left-1/2 w-1/4 max-lg:w-1/2 max-sm:w-11/12 right-auto bottom-auto -translate-x-1/2 -translate-y-1/2"
      overlayClassName="bg-black w-full h-full absolute top-0 left-0 bg-opacity-60"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {title && (
        <div className="flex justify-between items-center text-white text-lg border-b py-4 px-6">
          <p className="text-white font-bold text-2xl">{title}</p>
          <AiOutlineClose onClick={handleClose} className="cursor-pointer" />
        </div>
      )}
      <div className="h-full overflow-scroll no-scrollbar">{children}</div>
    </Modal>
  );
}
